// @flow

import React, { Component } from 'react';
import { Image, Navbar, Nav, NavDropdown, MenuItem } from 'react-bootstrap/lib';
import styler from 'react-styling';
import 'font-awesome/css/font-awesome.min.css';
import logo from '../../img/symfoni_logo.png';
import { REDIRECT_URL } from '../../../config';

const style = styler `
  Logo
    max-width: 180px
    float: left
    padding: 16px 0 14px 5px
  `;

class NavbarTop extends Component {
  props: {
    languagedata: Object,
    me: Object,
  }

  _handleLogout = () => {
    const request = new Request('logout', {
      method: 'POST',
      credentials: 'same-origin',
    });
    fetch(request).then(() => {
      window.location.replace(REDIRECT_URL);
    }).catch(() => {
      // todo: handle/track error
      window.location.replace(REDIRECT_URL);
    });
  }

  render() {
    const lang = this.props.languagedata;
    return (
      <Navbar fixedTop fluid>
        <Navbar.Header>
          <Navbar.Brand>
            <Image style={style.Logo} src={logo} alt="Logo" />
          </Navbar.Brand>
        </Navbar.Header>
        <Nav pullRight className="pull-right">
          <NavDropdown
            eventKey={3}
            title={[<i key={1} className="fa fa-user-circle" />]}
            id="basic-nav-dropdown"
          >
            <MenuItem eventKey={3.2} onSelect={this._handleLogout}><i className="fa fa-sign-out" aria-hidden="true" style={{ marginRight: '5px' }} />{lang.log_out}</MenuItem>
          </NavDropdown>
        </Nav>
      </Navbar>
    );
  }
}

export default NavbarTop;



// WEBPACK FOOTER //
// ./src/js/Components/NavbarTop.js